module.exports = "/_next/static/images/d8687047dcb61dcf861f0f7828891b18-slide-1-large.png";